import { Component, HostListener, ViewChild } from '@angular/core';
import { CanDeactivateComponent } from '@app/interfaces';
import { PayrollModuleMenuService } from '@app/modules/payroll/services/payroll-module-menu.service';
import { CompanyInformationForm } from '@forms/payroll/components';

const WARNING_MESSAGE = 'Are you sure you want to leave? You have unsaved data!';

@Component({
    selector: 'app-self-onboarding-company-information-view',
    templateUrl: './company-information.template.html',
})
export class SelfOnboardingCompanyInformationView implements CanDeactivateComponent {
    isLoading = true;
    isEditing = false;
    @ViewChild('companyInformationForm') companyInformationForm: CompanyInformationForm;

    constructor(public payrollModuleMenuService: PayrollModuleMenuService) {}

    @HostListener('window:beforeunload', ['$event'])
    warn($event: BeforeUnloadEvent): void {
        if (this.shouldConfirmNavigation()) {
            $event.returnValue = WARNING_MESSAGE;
        }
    }

    canDeactivate(): boolean {
        return this.shouldConfirmNavigation() ? window.confirm(WARNING_MESSAGE) : true;
    }

    private shouldConfirmNavigation(): boolean {
        return this.isEditing && this.companyInformationForm.form.dirty;
    }
}
